import { defineIntegration, consoleSandbox } from '@sentry/core/browser';

const browserTracingIntegrationShim = defineIntegration((_options) => {
  consoleSandbox(() => {
    console.warn("You are using browserTracingIntegration() even though this bundle does not include tracing.");
  });
  return {
    name: "BrowserTracing"
  };
});

export { browserTracingIntegrationShim };
//# sourceMappingURL=BrowserTracing.js.map
